import { DeclinedData } from "../../components/datatable/declinedRfqData";

const Rejectedrfq = () => {
  return <DeclinedData />;
};

export default Rejectedrfq;
